import { lineConfiguration, transformConfiguration } from './config/lines.ts';
import { consoleString } from "../utils";

const sbShowing:boolean[] = []
let sbReveals:NodeListOf<HTMLElement>

const animateLinesSetup = () => {
  Array.from(sbReveals).forEach((item: HTMLElement, idx: number) => {
    item.classList.add(`sb-bg-${item.dataset.type}`)
    const type = item.dataset.type!.split('-')[1]
    item.innerHTML = lineConfiguration[type]
    const svg:SVGElement = item.querySelector('svg')!
    svg.id = `sb-bg-${item.dataset.type}${idx}`
  })
  setupReveal()
}

const setupReveal = async () => {
  console.time('✅ anime library scripts loaded in')
  await import('animejs')
    .then((mod) => {
      console.timeEnd('✅ anime library scripts loaded in')
      const anime = mod.default;
      sbRevealLines(anime)
      window.addEventListener('scroll', () => {
        sbRevealLines(anime)
      })
    })
    .catch((err) => {
      console.log(
        `%c❌ an error occurred while loading the anime library\n`,
        consoleString.error,
        err
      )
    })
}

const sbRevealLines = (anime) => {
  sbReveals.forEach((item:HTMLElement, idx:number) => {
    var windowHeight = window.innerHeight;
    var elementTop = item.getBoundingClientRect().top;
    var elementVisible = 150;

    if (elementTop < windowHeight - elementVisible) {
      item.classList.add("active");

      if (sbShowing[idx] == false) {

        anime({
          targets: `#sb-bg-${item.dataset.type}${idx} path`,
          strokeDashoffset: [anime.setDashoffset, 0],
          easing: "easeInOutSine",
          duration: 1000,
          direction: "alternate",
          loop: false,
        });
        sbShowing[idx] = true;
      }
    } else {
      item.classList.remove("active");
      sbShowing[idx] = false;
    }
  })
}

const transformLine = () => {
  var a = 1440;
  var b = Math.min(screen.width, a);

  sbReveals.forEach((item:HTMLElement) => {
    const svg:SVGElement = item.querySelector('svg')!
    const type:string = item.dataset.type!
    const leftVal = Math.max(document.body.offsetWidth - a - 50, 0) / 2 + transformConfiguration[type].left
    svg.setAttribute('width', `${b * transformConfiguration[type].widthRatio1 + (a - b) * b * transformConfiguration[type].widthRatio2}px`)
    item.style.left = `${leftVal}${transformConfiguration[type].suffix}`
    item.style.bottom = `${-(b * transformConfiguration[type].bottomRatio1 + (a - b) * b * transformConfiguration[type].bottomRatio2)}px`
  })
}

const transformLineInit = () => {
  transformLine();
  window.addEventListener('resize', () => {
    transformLine()
  })
}

const lineAnimationInit = (lineNodeList: NodeListOf<HTMLElement>) => {
  if (lineNodeList.length) {
    sbReveals = lineNodeList
    animateLinesSetup()
    transformLineInit()
  }
}

export {
  lineAnimationInit,
}
